import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabCpp as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabCpp = (props: {
  data: AprResponseModel | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const veteranField = () => {
    const propertyName = pn<AprResponseModel>("veterans");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.veterans}
      </DataDisplay>
    );
  };

  const activeDutyField = () => {
    const propertyName = pn<AprResponseModel>("activeDuty");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.activeDuty}
      </DataDisplay>
    );
  };

  const spouseActiveDutyField = () => {
    const propertyName = pn<AprResponseModel>("spouseActiveDuty");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.spouseActiveDuty}
      </DataDisplay>
    );
  };

  const childActiveDutyField = () => {
    const propertyName = pn<AprResponseModel>("childActiveDuty");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.childActiveDuty}
      </DataDisplay>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Military Connections</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {veteranField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {activeDutyField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {spouseActiveDutyField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {childActiveDutyField()}
              </Grid>
              <GridBreak />
              <GridBreak />
            </Grid>
          </Grid>
          
        </Grid>
      </Stack>
    </Card>
  );
};
